var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-right remaining-length font-small text-dark-gray"},[_c('span',[_vm._v("残り"+_vm._s(_vm.remainingLength)+"文字")])])}
var staticRenderFns = []

export { render, staticRenderFns }